import { AreaData } from "./area.model";

import { Role } from "./role";



export class Employee {

  areaCode: number;

  employeeId: number; // Maps to emp_id in database

  employeeName: string; // Maps to emp_name in database

  employeePhone: number; // Maps to emp_phone in database

  employeeEmail: string; // Maps to emp_email in database

  employeeRole?: string;

  employeeStatus: string; // Maps to emp_status in database

  employeeAreaId?: string;

  employeePassword: string; // Maps to emp_password in database

  employeeCreationDate: string; // Maps to emp_creation_date in database

  employeeAction: string;

  employeeDepartment?: string; // Maps to emp_department in database

  roles:Role[];

  areas:AreaData[];

  jobTitle?: string; // Maps to job_title in database

  empAddress?: string; // Maps to emp_address in database

  educationLevel?: string; // Maps to education_level in database

  startDate?: string; // Maps to start_date in database

  emergencyName?: string; // Maps to emergency_name in database

  emergencyPhone?: string; // Maps to emergency_phone in database

  emergencyAddress?: string; // Maps to emergency_address in database

  emergencyRelation?: string; // Maps to emergency_relation in database

  guarantorName?: string; // Maps to guarantor_name in database

  guarantorPhone?: string; // Maps to guarantor_phone in database

  guarantorAddress?: string; // Maps to guarantor_address in database

  referenceName?: string; // Maps to reference_name in database

  referencePhone?: string; // Maps to reference_phone in database

  employeePhoto?: string; // Maps to employee_photo in database (longblob)

  baseSalary?: number; // Maps to base_salary in database

  bankName?: string; // Maps to bank_name in database

  bankAccount?: string; // Maps to bank_account in database

  bankAmount?: number; // Maps to bank_amount in database

  employeeGrade?: string; // Maps to employee_grade in database

  taxId?: string; // Maps to tax_id in database

  guarantor?: string; // Maps to Guararntor in database

  // Document fields
  employeeDocument?: File;
  documentPath?: string; // Maps to document_path in database
  documentName?: string; // Maps to document_name in database
  documentType?: string; // Maps to document_type in database
  documentSize?: number; // Maps to document_size in database

    // Qiyaas field
  qiyaas?: string; // Maps to qiyaas in database - "Enable" or "Disable"

  customerUpdate?: string; // Maps to customer_update in database

  smsEnabled?: boolean; // Maps to sms_enabled in database - per-employee SMS opt-out

  canCreateBill?: boolean; // Maps to can_create_bill — false disables bill creation

  canMakePayment?: boolean; // Maps to can_make_payment — false disables payments

  branchName?: string; // Maps to branch_name in database - restricts user to that branch

  employeeSignature?: string;

  hrSignature?: string;

  employeeSignatureDate?: string;

  hrSignatureDate?: string;

  
}
